<template>
  <div class="call-features">
    <img class="phone" :src="phone">
    <img class="circle" :src="circle">
    <transition-group name="icon-overlays">
      <img
        v-for="layer of selectedLayers"
        :key="layer.id"
        class="icon-overlay"
        :src="layer.img"
        :class="[`layer-${layer.id}`, {'behind': layer.behindPhone}]"
        :alt="`Call features illustration - ${layer.id}`"
      >
    </transition-group>
  </div>
</template>

<script>
export default {
  name: 'CallFeaturesIcon',
  props: {
    question: {
      type: Object,
      required: true
    },
    answer: {
      type: Object,
      required: true
    }
  },
  data () {
    return {
      circle: require('@/assets/answer-icons/call-features/features-circle.svg'),
      phone: require('@/assets/answer-icons/call-features/features-phone.svg'),
      layers: [
        {
          id: 'barring',
          img: require('@/assets/answer-icons/call-features/features-barring.svg')
        },
        {
          id: 'conference',
          behindPhone: true,
          img: require('@/assets/answer-icons/call-features/features-conference.svg')
        },
        {
          id: 'display',
          img: require('@/assets/answer-icons/call-features/features-display.svg')
        },
        {
          id: 'diversion',
          img: require('@/assets/answer-icons/call-features/features-diversion.svg')
        },
        {
          id: 'ring-back',
          img: require('@/assets/answer-icons/call-features/features-ring-back.svg')
        },
        {
          id: 'waiting',
          img: require('@/assets/answer-icons/call-features/features-waiting.svg')
        }
      ]
    }
  },

  computed: {
    selectedLayers () {
      if (!this.answer || !this.answer.result) return false

      const selectedIds = this.answer.result.map(({ value }) => value)
      return this.layers.filter(layer => selectedIds.includes(layer.id))
    }
  }
}
</script>

<style scoped lang="scss">
img {
  position: absolute;
  left: 0;
  top: 0;
}

.phone {
    position: absolute;
    z-index: 75;
  }

  .circle {
    position: absolute;
    z-index: 25;
  }

.icon-overlay {
  position: absolute;
  top: 0;
  left: 0;
  z-index: 100;

  &.behind {
    z-index: 50;
  }
}

.icon-overlays-enter-active,
.icon-overlays-leave-active {
  transition: all 1s cubic-bezier(0.45, 1.355, 0.53, 1.005);
  transform-origin: 20% 80%;
}
.icon-overlays-enter,
.icon-overlays-leave-to {
  opacity: 0;
  transform: scale(0.8) rotate(-10deg);
}
</style>
